import { GiftDetails } from "@payment-client/interfaces/SwiggyMoney";

export const ENDPOINT = {
    PLACE_ORDER: "/api/v1/order/place",
    CONFIRM_ORDER: "/api/v1/order/confirm",
    GIFTING_PLACE_ORDER: "/api/v3/gifting-order/place",
    GIFTING_CONFIRM_ORDER: "/api/v3/gifting-order/confirm",
};

export interface PlaceOrderParams {
    addressId: string | number;
    paymentMethod: string;
    orderType?: string;
    orderComments?: string;
    proceedWithDuplicateOrder?: boolean;
    useJuspayNative?: boolean;
    [key: string]: unknown;
    // TODO - Cleanup required after feature
    giftDetails?: GiftDetails;
    cbccfdApplicationNumber?: string;
}

export interface ConfirmOrderParams {
    transactionId: string;
    orderId: string | number;
    giftDetails?: GiftDetails;
    [key: string]: unknown;
}
